var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[(_vm.isNextQuoted)?_c('CommentQuote',{attrs:{"line":_vm.nextLine,"quoteRegex":_vm.quoteRegex}}):[_c('CommentLineWithMention',{attrs:{"message":_vm.nextLine}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }